export default __webpack_public_path__ + "static/media/people-icon.6df6f1ba.svg";